import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    navbarHidden: false,
    selectedAudience: '',
    selectedLocation: '',
    selectedServiceType: '',
    selectedTopic: '',
    searchTerm: '',
  },
  mutations: {
    setNavbarHidden(state, payload) {
      state.navbarHidden = payload; // eslint-disable-line no-param-reassign
    },
    setSelectedAudience(state, payload) {
      state.selectedAudience = payload; // eslint-disable-line no-param-reassign
    },
    setSelectedLocation(state, payload) {
      state.selectedLocation = payload; // eslint-disable-line no-param-reassign
    },
    setSelectedServiceType(state, payload) {
      state.selectedServiceType = payload; // eslint-disable-line no-param-reassign
    },
    setSelectedTopic(state, payload) {
      state.selectedTopic = payload; // eslint-disable-line no-param-reassign
    },
    setSearchTerm(state, payload) {
      state.searchTerm = payload; // eslint-disable-line no-param-reassign
    },
  },
  actions: {
    setNavbarHidden(context, payload) {
      if (payload !== context.state.navbarHidden) {
        context.commit('setNavbarHidden', payload);
      }
    },
  },
});
